import { Modelo } from '@ext/index';
import * as Types from './Pago.types';
import moment, { Moment } from 'moment';

export class IPago extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public IdExterna: number = 0;
    public Propio: boolean = false;

    public IdGateway: string = '';
    public Esquema: string = '';
    public Observacion: string = '';
    public Plataforma: Types.Plataformas = Types.Plataformas.NoEspecificado;
    public Cuenta: string = '';
    public Tipo: Types.Tipos = Types.Tipos.NoEspecificado;
    public Modo: string = '';
    public DetalleTipo: string = '';
    public Estado: Types.Estados = Types.Estados.Pendiente;
    public EstadoPlataforma: string = '';
    public Pedidos: number[] = [];

    public Comprobante: string = '';
    public Operacion: string = '';
    public Banco: string = '';
    public Cajero: string = '';
    public Recibo: string = '';

    public Cliente: Cliente = {
        Id: 0,
        Documento: '',
        Email: '',
        Nombre: '',
        Telefono: '',
    };

    public Importes: Importes = {
        Moneda: 'ARS',

        Total: 0,
        Pagado: 0,
        Impuestos: 0,
        Descuento: 0,
        Recibido: 0,
        Devuelto: 0,
        SobrePago: 0
    };

    public Financiacion: Financiacion = {
        Cuotas: 0,
        Importe: 0,
    };

    public Fechas: Fechas = {
        Creacion: moment( '' ),
        Aprobacion: moment( '' ),
        Edicion: moment( '' ),
        Liberacion: moment( '' )
    };

    public CostoFinanciero: Costo = {
        Monto: 0,
        Porcentaje: 0
    };

    public CostoMedioDePago: Costo = {
        Monto: 0,
        Porcentaje: 0
    };

    public Comision: Costo = {
        Monto: 0,
        Porcentaje: 0
    };




    public Descripcion: string = '';
    public ReferenciaExterna: string = '';



    public CargoPorEnvio: number = 0;
    public IncluyeEnvio: boolean = false;
    public DireccionIp: string = '';



    public getJson(): any
    {
        let json: any = {};

        if ( this.IdExterna )
            json.id_externa = this.IdExterna;
        else
            json.id_externa = null;

        if ( this.Cuenta )
            json.cuenta = this.Cuenta;
        else
            json.cuenta = null;

        json.modo = this.Modo;
        json.observacion = this.Observacion;
        json.esquema = this.Esquema;
        json.propio = this.Propio ? 'S' : 'N';
        json.id_gateway = this.IdGateway;
        json.plataforma = this.Plataforma.Id;
        json.cuenta = this.Cuenta;
        json.tipo = this.Tipo.Id;
        json.detalle_tipo = this.DetalleTipo;
        json.estado = this.Estado.Id;
        json.estado_plataforma = this.EstadoPlataforma;

        json.cliente_id = this.Cliente.Id;
        json.cliente_nombre = this.Cliente.Nombre;
        json.cliente_documento = this.Cliente.Documento;
        json.cliente_email = this.Cliente.Email;
        json.cliente_telefono = this.Cliente.Telefono;

        json.importe_total = this.Importes.Total;
        json.importe_pagado = this.Importes.Pagado;
        json.importe_impuestos = this.Importes.Impuestos;
        json.importe_descuento = this.Importes.Descuento;
        json.importe_recibido = this.Importes.Recibido;
        json.importe_sobrepago = this.Importes.SobrePago;
        json.importe_devuelto = this.Importes.Devuelto;
        json.moneda = this.Importes.Moneda;
        json.descripcion = this.Descripcion;
        json.referencia_externa = this.ReferenciaExterna;

        json.comision = this.Comision.Monto;
        json.comision_porcentaje = this.Comision.Porcentaje;

        json.costo_financiero = this.CostoFinanciero.Monto;
        json.costo_financiero_porcentaje = this.CostoFinanciero.Porcentaje;
        json.costo_medio_de_pago = this.CostoMedioDePago.Monto;
        json.costo_medio_de_pago_porcentaje = this.CostoMedioDePago.Porcentaje;

        json.fecha_creacion = this.Fechas.Creacion.toSQL();
        json.fecha_aprobacion = this.Fechas.Aprobacion.toSQL();
        json.fecha_edicion = this.Fechas.Edicion.toSQL();
        json.fecha_liberacion = this.Fechas.Liberacion.toSQL();

        json.financiacion_cuotas = this.Financiacion.Cuotas;
        json.financiacion_importe_cuota = this.Financiacion.Importe;
        json.cargo_por_envio = this.CargoPorEnvio;
        json.incluye_envio = this.IncluyeEnvio ? 'S' : 'N';
        json.direccion_ip = this.DireccionIp;

        return json;
    }

    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.IdExterna = !this.Json.id_externa ? 0 : this.Json.id_externa;
        this.Propio = this.Json.propio === 'S';

        this.IdGateway = !this.Json.id_gateway ? '' : this.Json.id_gateway;
        this.Esquema = !this.Json.esquema ? '' : this.Json.esquema;
        this.Modo = !this.Json.esquema ? '' : this.Json.esquema;
        this.Observacion = !this.Json.observacion ? '' : this.Json.observacion;

        this.Plataforma = Types.Plataformas.toTipo( this.Json.plataforma );

        this.Cuenta = !this.Json.cuenta ? '' : this.Json.cuenta;
        this.Tipo = Types.Tipos.toTipo( this.Json.tipo );

        this.DetalleTipo = !this.Json.detalle_tipo ? '' : this.Json.detalle_tipo;

        this.Estado = Types.Estados.toTipo( this.Json.estado );

        this.EstadoPlataforma = !this.Json.estado_plataforma ? '' : this.Json.estado_plataforma;
        this.Cliente.Id = !this.Json.cliente_id ? '' : this.Json.cliente_id;
        this.Cliente.Nombre = !this.Json.cliente_nombre ? '' : this.Json.cliente_nombre;
        this.Cliente.Documento = !this.Json.cliente_documento ? '' : this.Json.cliente_documento;
        this.Cliente.Email = !this.Json.cliente_email ? '' : this.Json.cliente_email;
        this.Cliente.Telefono = !this.Json.cliente_telefono ? '' : this.Json.cliente_telefono;
        this.Importes.Total = !this.Json.importe_total ? 0 : this.Json.importe_total;
        this.Importes.Pagado = !this.Json.importe_pagado ? 0 : this.Json.importe_pagado;
        this.Importes.Impuestos = !this.Json.importe_impuestos ? 0 : this.Json.importe_impuestos;
        this.Importes.Descuento = !this.Json.importe_descuento ? 0 : this.Json.importe_descuento;
        this.Importes.Recibido = !this.Json.importe_recibido ? 0 : this.Json.importe_recibido;
        this.Importes.SobrePago = !this.Json.importe_sobrepago ? 0 : this.Json.importe_sobrepago;
        this.Importes.Devuelto = !this.Json.importe_devuelto ? 0 : this.Json.importe_devuelto;
        this.Importes.Moneda = !this.Json.moneda ? '' : this.Json.moneda;
        this.Descripcion = !this.Json.descripcion ? '' : this.Json.descripcion;
        this.ReferenciaExterna = !this.Json.referencia_externa ? '' : this.Json.referencia_externa;
        this.Comision.Monto = !this.Json.comision ? 0 : this.Json.comision;
        this.Comision.Porcentaje = !this.Json.comision_porcentaje ? 0 : this.Json.comision_porcentaje;
        this.CostoFinanciero.Monto = !this.Json.costo_financiero ? 0 : this.Json.costo_financiero;
        this.CostoFinanciero.Porcentaje = !this.Json.costo_financiero_porcentaje ? 0 : this.Json.costo_financiero_porcentaje;
        this.CostoMedioDePago.Monto = !this.Json.costo_medio_de_pago ? 0 : this.Json.costo_medio_de_pago;
        this.CostoMedioDePago.Porcentaje = !this.Json.costo_medio_de_pago_porcentaje ? 0 : this.Json.costo_medio_de_pago_porcentaje;
        this.Fechas.Creacion = !this.Json.fecha_creacion ? moment( '' ) : moment( this.Json.fecha_creacion );
        this.Fechas.Aprobacion = !this.Json.fecha_aprobacion ? moment( '' ) : moment( this.Json.fecha_aprobacion );
        this.Fechas.Edicion = !this.Json.fecha_edicion ? moment( '' ) : moment( this.Json.fecha_edicion );
        this.Fechas.Liberacion = !this.Json.fecha_liberacion ? moment( '' ) : moment( this.Json.fecha_liberacion );
        this.Financiacion.Cuotas = !this.Json.financiacion_cuotas ? 0 : this.Json.financiacion_cuotas;
        this.Financiacion.Importe = !this.Json.financiacion_importe_cuota ? 0 : this.Json.financiacion_importe_cuota;
        this.CargoPorEnvio = !this.Json.cargo_por_envio ? 0 : this.Json.cargo_por_envio;
        this.IncluyeEnvio = !this.Json.incluye_envio ? false : this.Json.incluye_envio === 'S';
        this.DireccionIp = !this.Json.direccion_ip ? '' : this.Json.direccion_ip;
        this.Pedidos = !this.Json.pedidos ? [] : this.Json.pedidos;

        this.Comprobante = !this.Json.comprobante ? '' : this.Json.comprobante ;
        this.Banco = !this.Json.banco ? '' : this.Json.banco;
        this.Cajero = !this.Json.cajero ? '' : this.Json.cajero;
        this.Operacion = !this.Json.operacion ? '' : this.Json.operacion;
        this.Recibo = !this.Json.recibo ? '' : this.Json.recibo;

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IPago )
    {
        this.Model = Model;
    }

    public Model: IPago;
}


type Importes = {
    Moneda: string,
    Total: number,
    Pagado: number,
    Impuestos: number,
    Descuento: number,
    Recibido: number,
    Devuelto: number,
    SobrePago: number,
};

type Financiacion = {
    Cuotas: number,
    Importe: number,
};


type Cliente = {
    Id?: number;
    Nombre?: string;
    Documento?: string;
    Email?: string;
    Telefono?: string;
};

type Fechas = {
    Creacion: Moment;
    Aprobacion: Moment;
    Edicion: Moment;
    Liberacion: Moment;
};
type Costo = {

    Monto: number;
    Porcentaje: number;
};